export interface SavePromocion {
  autosave: boolean;
  promo: Promocion;
}

export interface Promocion {
  id_promo: string;
  descripcion_corta: string;
  descripcion_larga: string;
  fecha_inicio: string;
  fecha_fin: string;
  tipo_promo: number;
  especif_calculo_cantidad: number;
  cantidad_minima: number;
  cantidad_maxima: number;
  control_maximo: number;
  control_cantidad: number;
  promo_exclusiva_hh: number;
  aplica_proporcionalidad: number;
  cambio_condicion_pago: number;
  condicion_pago: number;
  excluye_bonificacion_hh: number;
  suma_por_grupos: number;
  aplica_compensacion: number;
  porcentaje_descuento: number;
  monto_inicial: number;
  monto_final: number;
  cond_marca_submarca: number;
  numero_maximo_compras: number;
  cond_grupo_cliente: number;
  cond_cliente: number;
  cond_vendedor: number;
  cond_oficina_venta: number;
  negociacion_puntal: number;
  cond_tiers: number;
}

export interface DuplicatePromoDTO {
  promoOrigen: string;
  idPromo: string;
  fechaInicio: string;
  fechaFin: string;
}

export interface Submarca {
  idSubMarca: string;
  descripcionSubMarca: string;
}

export const cmbSiNo = [
  {
    id: 1,
    descripcion: 'Si'
  },
  {
    id: 2,
    descripcion: 'No'
  },
];
export const cmbExcluyePromosHH = [
  {
    id: 1,
    descripcion: 'No Aplica'
  },
  {
    id: 2,
    descripcion: 'Solo Bonificador'
  }
];
export const cmbEspecifCalculoCantidad = [
  {
    id: 1,
    descripcion: 'Por Cada'
  },
  {
    id: 2,
    descripcion: 'Por Compras Superiores'
  },
];
export const cmbControlCantidad = [
  {
    id: 1,
    descripcion: 'Cant. Cajas'
  },
  {
    id: 2,
    descripcion: 'Cant. Unidades'
  },
  {
    id: 3,
    descripcion: 'Cant. Kilos'
  },
  {
    id: 4,
    descripcion: 'Cant. Dólares'
  },
];
export const cmbControlMaximo = [
  {
    id: 1,
    descripcion: 'Max. por Item'
  },
  {
    id: 2,
    descripcion: 'Max. por Cliente'
  },
  {
    id: 3,
    descripcion: 'No Aplica'
  },
];
export const cmbCondicionPago = [
  {
    id: 1,
    descripcion: 'Items'
  },
  {
    id: 2,
    descripcion: 'Caje'
  },
  {
    id: 3,
    descripcion: 'Consignación'
  },
  {
    id: 4,
    descripcion: 'Yapa Descuento Adicional'
  },
];
export const cmboInclusionExclusion = [
  {
    id: 1,
    descripcion: 'Inclusión',
  },
  {
    id: 2,
    descripcion: 'Exclusión',
  },
  {
    id: 3,
    descripcion: 'No Aplica',
  },
];
